export default "__VITE_ASSET__60359aa0__"